import IApiResponse from '@/types/api-response'
import axios from '@/utils/axios-instance'

export const getUserInfo = async (): Promise<IApiResponse<any>> => {
	const { data } = await axios.get<IApiResponse<any>>('/api/user-info')
	return data
}